import React, { useState } from 'react';
import Sidebar from "../../DashboardLayout/Sidebar/Sidebar";
import hamburgur from "../../../components/navbar/images/menu-icon.svg";
import magnifying from "../../../components/navbar/images/magnifying.svg";
import { Link, useLocation } from 'react-router-dom';
import SearchBar from "../../searchbar";
import { useSelector } from 'react-redux';

interface MobileTopBarProps {
  brand?: string;
  showSearch?: boolean;
  showMenu?: boolean;
  onSearchClick?: () => void;
  onMenuClick?: () => void;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
  showSidebar?: boolean; // New prop to control sidebar visibility
  onMobileManageDonations?: () => void;
  onMobileManageStore?: () => void;
  onMobileManageWishlist?: () => void;
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({
  brand = "NEDDIE",
  showSearch = true,
  showMenu = true,
  onSearchClick,
  onMenuClick,
  leftIcon,
  rightIcon,
  className = "",
  showSidebar = true,
  onMobileManageDonations,
  onMobileManageStore,
  onMobileManageWishlist
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // const [searchBarOpen, setSearchBarOpen] = useState(false);
  const location = useLocation();
  const reduxState = useSelector((state: any) => state);
  const reduxUser = useSelector((state: any) => state.signin);
  const reduxOrg = useSelector((state: any) => state.org);
  const logged = reduxState.signin?.type || 'loggedOut';
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  
  // Check if we're on the dashboard route
  const isDashboardRoute = location.pathname === '/dashboard';
  
  // Get username same way as DashboardLayout
  const userRole = reduxUser?.type === 'individual' ? 'individual' : 'nonprofit';
  const headerName = userRole === 'individual'
    ? `${reduxUser?.firstName || ''} ${reduxUser?.lastName || ''}`.trim() || 'User'
    : (reduxOrg?.name || 'Organization');

  // Handle menu click - either use custom handler or open sidebar
  const handleMenuClick = () => {
    if (onMenuClick) {
      onMenuClick();
    } else if (showSidebar) {
      setSidebarOpen(true);
    }
  };

  // Handle search click - toggle searchbar visibility
  const handleSearchClick = () => {
    setSearchBarOpen(!searchBarOpen);
    if (onSearchClick) {
      onSearchClick();
    }
  };

  return (
    <>
    <div className="mobile-dashboard">
        <div className={`md-topbar ${className}`}>
        {/* Left section - Search or custom icon */}
        {!(isDashboardRoute && userRole === 'individual') && 
        <button
          className="md-ico md-search"
          aria-label="Search"
          onClick={handleSearchClick}
          style={{ display: showSearch ? 'flex' : 'none' }}
        >
          {leftIcon || <img style={{width:"24px"}} src={magnifying} alt="search" />}
        </button>}

        {/* Center - Brand or Username */}
        <div className="md-brand mx-auto">
          <Link style={{color:"#4971c2"}} to={'/'}> {brand}</Link>
         </div>

        {/* Right section - Menu or custom icon */}
        <button
          className="md-ico md-burger"
          aria-label="Menu"
          onClick={handleMenuClick}
          style={{ display: showMenu ? 'flex' : 'none' }}
        >
          {/* <span />
          <span />
          <span /> */}
          {rightIcon || <img style={{width:"24px"}} src={hamburgur} alt="menu" />}
        </button>
      </div>

      {/* Welcome message and Search Bar - only show on dashboard route */}
        {showSearch && searchBarOpen ? (
          // Case 1: Only Search Bar
          <div className="mobile-searchbar-container" style={{ padding: '12px 20px 0px 20px' }}>
            <SearchBar />
          </div>
        ) : (
          // Case 2: Dashboard AND Individual User
          isDashboardRoute && userRole === 'individual' && (
            <>
              <div style={{ padding: '12px 20px 0px 20px', fontSize: '18px', color: '#333', fontWeight: 600 }}>
                Welcome, {headerName}
              </div>

              <div className="mobile-searchbar-container" style={{ padding: '12px 20px 0px 20px' }}>
                <SearchBar />
              </div>
            </>
          )
        )}

    </div>

      {/* Sidebar Backdrop */}
      {showSidebar && sidebarOpen && (
        <div
          className="mobile-sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Mobile Sidebar */}
      {showSidebar && (
        <Sidebar
          collapsed={false}
          mobileOpen={sidebarOpen}
          onToggle={() => setSidebarOpen(false)}
          onMobileToggle={() => setSidebarOpen(false)}
          userRole={logged}
          isMobile={true}
          onMobileManageDonations={onMobileManageDonations}
          onMobileManageStore={onMobileManageStore}
          onMobileManageWishlist={onMobileManageWishlist}
        />
      )}
    </>
  );
};

export default MobileTopBar;